module.exports = __webpack_public_path__ + "img/1513931593.645971db.jpg";